<span *ngIf="type() === 0" class='container-money-symbol' #moneySymbol></span>
<span *ngIf="type() === 1" [innerHTML]="valor"></span>